import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Carousel from './components/Carousel';
import Player from './components/ControlOpus';
import Layer from './components/Layer';
import News from './components/News';
import AdminLogin from './pages/AdminLogin';
import AdminNews from './pages/AdminNews';

function HomePage() {
    return (
        <div className='homepage-container'>
            <Layer />
            <div className='col main-section'>
                <img className='header-logo' src="/logo.png" />
                <div className='main-content'>
                    <span>Prati ritam tvoga grada</span>
                    <div className='row'>
                        <span className="box">Telefon: <b>0628485840</b></span>
                        <span className="box">Email: <b>tvoj.neko1981@gmail.com</b></span>
                    </div>
                </div>

                <Player />

                <div className='promotions-section'>
                    <Carousel
                        images={[
                            { image: "/help.jpg" },
                            { image: "/radoznalac2.webp", url: "https://www.facebook.com/pisamcenadar"},
                            { image: "apartments.webp" },
                            { image: "/kloperaj.jpg" },
                            { image: "/help_3.webp" }
                        ]}
                    />
                </div>

                <div className='news-section'>
                    <News onClose={() => {}} />
                </div>

                <div className='advert row'>
                    <img src="/demi-logo.png"></img>
                    <div className='col'>
                        <span>Pravio: Andrija Kovač</span>
                        <a href='https://demvamko.github.io'>&nbsp;https://demvamko.github.io</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/news" element={<AdminNews />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App;
